import React from 'react'
import { Link } from 'react-router-dom'
import {makeFilterLabel} from "./PluginListHelper";

function FilteredTitle(props) {
  const { filter } = props

  return (
    <>
      {filter &&
        <Link className="link_back" to="/plugins">
          <span className="ico_blog ico_back">검색 전으로 돌아가기</span>
        </Link>
      }
      <span className="txt_result">{makeFilterLabel(filter)}</span> 플러그인
    </>
  )
}


function SearchTitleText(props) {
  const { searchKeyword } = props
  return (
    <>
      <span className="txt_result">{searchKeyword}</span> 검색결과
      <Link className="link_back" to="/plugins">
        <span className="ico_blog ico_back">검색 전으로 돌아가기</span>
      </Link>
    </>
  )
}

function TitleText(props) {
  const { filter, searchKeyword } = props
  if (searchKeyword.length > 0) {
    return <SearchTitleText searchKeyword={searchKeyword} />
  } else {
    return <FilteredTitle filter={filter} />
  }
}

function PluginListTitle(props) {
  const { count, filter, searchKeyword } = props
  return (
    <h3 className="tit_cont">
      <TitleText filter={filter} searchKeyword={searchKeyword} />
      <span className="txt_count">{count}</span>
    </h3>
  )
}

export default PluginListTitle
